import { ApolloClient, gql } from '@apollo/client';
import { getDocumentById } from '../../api/queries_v2';
import { CounterpartyPermissionLevel } from '../../types/counterparty-permissions';

type ResponsePayloadType = {
  id: string | number;
  additionalMessage?: string;
};

export const sendDocumentToReceiver =
  (
    documentId: string | number,
    additionalMessage?: string,
    counterpartyPermissionLevel?: CounterpartyPermissionLevel
  ) =>
  (client: ApolloClient<object>): Promise<ResponsePayloadType> => {
    const variables = {
      documentId,
      additionalMessage,
      counterpartyPermissionLevel,
    };

    const mutation = gql`
      mutation sendDocumentToReceiver(
        $documentId: ID!
        $additionalMessage: String
        $counterpartyPermissionLevel: CounterpartyPermissionLevel
      ) {
        sendDocumentToReceiver(
          documentId: $documentId
          additionalMessage: $additionalMessage
          confirm: true
          counterpartyPermissionLevel: $counterpartyPermissionLevel
        ) {
          id
        }
      }
    `;

    const refetchQueries = [
      {
        query: getDocumentById,
        variables: {
          documentId,
        },
      },
    ];

    return client.mutate({ mutation, variables, refetchQueries }).then(({ data }: Record<any, any>) => {
      return data.sendDocumentToReceiver;
    });
  };
